<template>
  <div class="enrollInputTextWrapper">
    <input type="text" placeholder="쿠폰을 입력해주세요." maxlength="15"
           v-model="text" v-on:keyup="returnTextLength" v-on:blur="onChangeText">
    <span>{{textLength + '/' + maxLength}}</span>
  </div>
</template>

<script>

export default {
  data () {
    return {
      text: '',
      textLength: 0,
      maxLength: 15
    }
  },
  methods: {
    returnTextLength: function (e) {
      this.setTextLength(e.target.value.length)
    },
    setTextLength: function (length) {
      this.textLength = length > 15 ? 15 : length
    },
    onChangeText: function () {
      this.textLength = this.text.length
      this.setTextInfoStore(this.text)
    },
    setTextInfoStore: function (text) {
      this.$store.commit('setEnrollStateValue', {type: 'coupon', subType: 'title', value: text !== '' ? text : null})
    }
  },
  created: function () {
    let beforeCoupon = this.$store.getters.getEnrollStateValue('coupon')
    if(beforeCoupon.title != null) {
      this.text = beforeCoupon.title
      this.setTextLength(beforeCoupon.title.length)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
input[type='text']{
  padding: 0 0 5px;
  font-size: 13px;
  border-top: none;
  border-left: none;
  border-right: none;
  border-bottom: 2px rgb(112,112,112) solid;
  width: 100%;
  outline: none;
}

.enrollInputTextWrapper{
  width: 128px;
  margin-top: 20px;
  margin-left: 5px;
  text-align: right;
}

.enrollInputTextWrapper > span{
  font-size: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/board/elements/enrollInputTextCoupon.vue